document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.swiper-container');

  sliders.forEach((slider) => {
    const swiperEl = slider.querySelector('.swiper');

    const swiper = new Swiper(swiperEl, {
      ...JSON.parse(swiperEl.getAttribute('data-slider')),
      slidesPerView: 'auto',
      centeredSlides: false,
      watchOverflow: true,
      on: {
        init() {
          alignTabs(this);
        },
        resize() {
          alignTabs(this);
        }
      }
    });

    function alignTabs(swiper) {
  const wrapper = swiper.wrapperEl;
  const totalSlidesWidth = wrapper.scrollWidth;
  const visibleAreaWidth = swiper.width;

  // Add a small buffer of 5px to account for rounding/padding
  if (totalSlidesWidth <= visibleAreaWidth + 5) {
    wrapper.style.justifyContent = 'center';
    wrapper.style.margin = '0 auto';
    wrapper.style.transform = 'none';
    swiper.allowTouchMove = false;
  } else {
    wrapper.style.justifyContent = 'flex-start';
    wrapper.style.margin = '0';
    wrapper.style.transform = '';
    swiper.allowTouchMove = true;
  }
}

  });
});
